// extracted by mini-css-extract-plugin
export default {"responsive":"Table_responsive__yJF4E","table":"Table_table__q8aJj"};